import React from 'react';

import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';

const FieldCheckbox = ({
  name,
  children,
  required,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();

  const onChange = () => (setFieldValue(name, !values[name]));

  return (
    <div className="field -binary-checkbox">
      <label htmlFor={name}>
        <Field id={name} name={name} type="checkbox" onChange={onChange} checked={values[name]} />
        <div className="checkmark">
          <span />
        </div>
        <div className="label-text">
          {children}
          {required && <span className="color-red ">*</span>}
          {errors[name] && touched[name] && <div className="field-invalid-small">{errors[name]}</div>}
        </div>
      </label>
    </div>
  );
};

FieldCheckbox.defaultProps = {
  required: false,
};

FieldCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.array.isRequired,
  required: PropTypes.bool,
};

export default FieldCheckbox;
